import { interpolate } from 'framer-motion';

export type ViewBox = [number, number, number, number];

export function toPath(
  data: number[][],
  opts: {
    rangeY: [number, number];
  }
) {
  const mixRangeY = interpolate(opts.rangeY, [opts.rangeY[1], opts.rangeY[0]]);

  return data
    .sort(([x1], [x2]) => x1 - x2)
    .map(([x, y]) => [x, mixRangeY(y)])
    .reduce(
      (acc, point) =>
        acc + (acc === '' ? `M ${point.join(',')}` : ` L ${point.join()}`),
      ''
    );
}
